import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/permissao`

    return {
        datatable(queryParms = {}) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
    }
}